<template>
  <div>
    <HMModalHeader
      :title="$t('CUSTOMERS.LINK.RESUME_SUBSCRIPTION')"
      @close="$emit('close')"
    />
    <form @submit.prevent="resumeOrder">
      <div>{{ $t('CUSTOMERS.TEXT.RESUME_SUBSCRIPTION_DESCRIPTION') }}</div>
      <HMModalFooter
        class="mt-3"
        :discardButton="$t('GENERAL.BUTTON.GO_BACK')"
        :submitButton="$t('CUSTOMERS.LINK.RESUME_SUBSCRIPTION')"
        :loading="isLoading"
        :disabled="isLoading"
        @close="$emit('close')"
      />
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { errorToMessage } from '@/core/utils/errors';

export default Vue.extend({
  name: 'ResumeCustomerOrderModal',
  props: {
    orderId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    async resumeOrder() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('sale/resumeOrder', {
          id: this.orderId,
        });
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
          text: this.$t('CUSTOMERS.NOTIFICATIONS.RESUME_ORDER_SUCCESS'),
        });
        this.$emit('close');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('CUSTOMERS.NOTIFICATIONS.RESUME_ORDER_ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
});
</script>

<style lang="scss" scoped></style>
